<template>
  <div class="custom-tabs-wrapper">
    <!-- 自定义导航 -->
    <div class="custom-tabs-nav">
      <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: activeTab === index.toString() }"
          class="custom-tab-item"
          @click="handleTabClick(index)"
      >
        {{ tab.label }}

      </div>

      <!-- 保留灰色填充区域 -->
      <div class="tab-nav-fill">
        <div class="gray-line"></div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="tab-content-wrapper">
      <!-- 标的介绍 -->
      <div v-show="activeTab === '0'" class="tab-content">
        <div class="contyern" v-html="outData.lotIntro"></div>
      </div>

      <!-- 拍卖公告 -->
      <div v-show="activeTab === '1'" class="tab-content">
        <div class="contyern" v-html="bulletinData.content"></div>
      </div>

      <!-- 竞买须知 -->
      <div v-show="activeTab === '2'" class="tab-content">
        <div class="contyern" v-html="bulletinData.notice"></div>
      </div>

      <!-- 竞价记录 -->
      <div v-show="activeTab === '3'" class="tab-content">
        <el-table :cell-style='styleCenter' :data="priceDataList" :header-cell-style='styleCenter'
                  :row-class-name="tableRowClassName" style="width: 100%">
          <el-table-column align="center" label="状态" prop="priceState">
            <template slot-scope="scope">
              {{
                (scope.row.quoted == outData.currentQuoted && scope.row.priceState == 1) ?
                    (outData.auctionStatus == 3 ? '成交' : '领先')
                    : (scope.row.priceState == -1 ? '回退' : '出局')
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="竞买号" prop="bidCode"></el-table-column>
          <el-table-column align="center" label="价格(元)" prop="quoted"></el-table-column>
          <el-table-column align="center" label="时间" prop="createTime"></el-table-column>
        </el-table>
        <el-pagination :current-page.sync="page.currentPage" :page-size="page.pageSize" :total="page.total"
                       align="right" layout="total, prev, pager, next" style="margin-top: 10px;"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getDetail} from '@/api/biz/auction/auctionBulletin';
import {priceList} from '@/api/biz/auction/lotQuoted';

export default {
  props: ['meetingData', 'outData'],
  data() {
    return {
      activeTab: '0',
      tabs: [
        {label: '标的介绍'},
        {label: '拍卖公告'},
        {label: '竞买须知'},
        {label: '竞价记录'}
      ],
      styleCenter: {'text-align': 'center'},
      bulletinData: {},
      priceDataList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
    }
  },
  created() {
    setTimeout(() => {
      this.getBulletinById()
    }, 1000)
  },
  methods: {
    // 切换tab
    handleTabClick(index) {
      this.activeTab = index.toString();
      if (index === 3) {
        this.queryPirceList();
      }
    },

    // 刷新竞价记录的方法
    refreshPriceList() {
      this.queryPirceList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryPirceList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryPirceList();
    },
    getBulletinById() {
      let bulletinTimer = setInterval(() => {
        if (this.meetingData.bulletinId) {
          getDetail(this.meetingData.bulletinId).then(res => {
            this.bulletinData = res.data.data;
          })
          clearInterval(bulletinTimer);
        }
      }, 3000)
    },
    queryPirceList() {
      let page = this.page;
      priceList(page.currentPage, page.pageSize, {lotId: this.outData.id}).then(res => {
        this.priceDataList = res.data.data.records.map(item => {
          return {
            ...item,
            quoted: parseFloat(item.quoted).toFixed(2)
          };
        });
        this.page.total = res.data.data.total;
      })
    },
    tableRowClassName({row}) {
      // 判断是否为领先或成交状态
      if ((row.quoted == this.outData.currentQuoted && row.priceState == 1)) {
        return 'red-row';
      }
      return '';
    }
  }

}
</script>

<style scoped>
.custom-tabs-wrapper {
  min-height: 700px;
  width: 100%;
  background: #fff;
  box-sizing: border-box;
}

.custom-tabs-nav {
  display: flex;
  position: relative;
  z-index: 2;
  width: 100%;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
}

.custom-tab-item {
  padding: 16px 30px;
  font-size: 20px;
  color: #333;
  background: #f5f5f5;
  border-right: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  white-space: nowrap;
  font-weight: 500;
  border-bottom: 1px solid #e0e0e0;
}

.custom-tab-item:hover {
  background: #f0f0f0;
}

.custom-tab-item:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #cd090e;
}

.custom-tab-item.active {
  color: #cd090e !important;
  background: #ffffff !important;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 500;
}

.custom-tab-item.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #cd090e;
}

.custom-tab-item:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 0;
  right: -1px;
  width: 1px;
  height: 100%;
  background: #e0e0e0;
}

.record-count {
  color: #666;
  font-size: 16px;
  margin-left: 4px;
  font-weight: normal;
}

/* 灰色填充区域 */
.tab-nav-fill {
  flex: 1;
  background: #f5f5f5;
  position: relative;
  border-bottom: 1px solid #e0e0e0;
}

/* 填充区域的灰杠 */
.tab-nav-fill .gray-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: 1px solid #e0e0e0;
}

/* 内容区域容器 - 增加左右内边距 */
.tab-content-wrapper {
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background: #ffffff;
  min-height: 650px;
  width: 100%;
  overflow: visible !important;
  /* 关键修改：增加左右内边距 */
  padding: 0 20px; /* 左右各20px内边距 */
  box-sizing: border-box;
}

.tab-content {
  padding: 20px 0; /* 上下20px，左右0（因为父容器已经有内边距） */
  overflow: visible !important;
  width: 100%;
  box-sizing: border-box;
}

.contyern {
  padding: 10px 0; /* 上下10px，左右0 */
  box-sizing: border-box;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

/* 表格也需要增加左右内边距 */
:deep(.el-table) {
  margin-top: 0;
  width: 100% !important;
  table-layout: auto !important;
  /* 表格本身增加内边距 */
  padding: 0 10px;
  box-sizing: border-box;
}

/* 表格单元格增加内边距 */
:deep(.el-table .cell) {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
  padding: 8px 15px !important; /* 增加左右内边距到15px */
  line-height: 1.5 !important;
  box-sizing: border-box;
}

/* 表格头和单元格也增加内边距 */
:deep(.el-table th),
:deep(.el-table td) {
  padding: 8px 15px !important; /* 增加左右内边距 */
  min-width: 80px;
  max-width: 300px;
  box-sizing: border-box;
}

/* 分页组件也增加左右内边距 */
:deep(.el-pagination) {
  margin-top: 20px;
  padding: 0 10px; /* 增加左右内边距 */
  box-sizing: border-box;
}

/* 针对拍卖公告中的长URL特别处理 */
.contyern a {
  word-break: break-all;
  color: #007AFF;
  text-decoration: underline;
}

/* 处理标题和列表的左右间距 */
.contyern h1,
.contyern h2,
.contyern h3,
.contyern h4,
.contyern h5 {
  word-break: break-word;
  margin: 15px 0 10px 0;
  padding: 0 5px; /* 标题也增加一点内边距 */
  box-sizing: border-box;
}

.contyern > p {
  line-height: 2;
  word-break: break-word;
  margin: 0 0 10px 0;
  padding: 0 5px; /* 段落增加内边距 */
  box-sizing: border-box;
}

.contyern ul,
.contyern ol {
  padding-left: 25px; /* 增加列表左侧内边距 */
  margin: 10px 0;
  padding-right: 5px; /* 右侧也增加内边距 */
  box-sizing: border-box;
}

.contyern li {
  word-break: break-word;
  margin-bottom: 5px;
  padding-right: 5px; /* 列表项右侧增加内边距 */
  box-sizing: border-box;
}

/* 表格的滚动容器如果有的话 */
:deep(.el-table__body-wrapper),
:deep(.el-table__header-wrapper) {
  padding: 0 5px; /* 表格滚动容器也增加内边距 */
  box-sizing: border-box;
}

/* 确保横向分割线也有间距 */
.contyern hr {
  margin: 20px 10px; /* 分割线左右增加间距 */
  border: none;
  border-top: 1px solid #e0e0e0;
}

:deep(.red-row) {
  color: #f3060d !important;
}

</style>
